import { createElement, Fragment } from 'react';
import { ErrorBoundary as ErrorBoundary$1 } from 'react-error-boundary';

function ErrorBoundary(props) {
  const {
    onError = () => {},
    children = null,
    ...rest
  } = props;

  // Assign a default fallback of a fragment if one is not supplied
  if (!rest.fallback && !rest.FallbackComponent && !rest.fallbackRender) {
    rest.fallback = /*#__PURE__*/createElement(Fragment);
  }
  const handleError = (error, info) => {
    // TODO: bonnet-next newrelic support?

    // handle user defined error callback
    if (typeof onError === 'function') {
      onError(error, info);
    }

    // display error in console
    // eslint-disable-next-line no-console
    console.log('Error: ', error, '\n Info: \n', info);
  };
  const componentProps = {
    ...rest,
    onError: handleError
  };
  return /*#__PURE__*/createElement(ErrorBoundary$1, componentProps, [children]);
}

export { ErrorBoundary };
